import type { ReviewsSummary, ReviewsListResponse, ReviewsScope, ListingType } from "./types";

const DEFAULT_API_URL = "https://api.baluu.io";

type FetchReviewsSummaryParams = {
  apiUrl?: string;
  businessSlug: string;
  scope?: ReviewsScope;
  listingId?: string;
  listingType?: ListingType;
};

export async function fetchReviewsSummary({
  apiUrl = DEFAULT_API_URL,
  businessSlug,
  scope = "business",
  listingId,
  listingType = "course",
}: FetchReviewsSummaryParams): Promise<ReviewsSummary> {
  const params = new URLSearchParams({
    businessSlug,
    scope,
    listingType,
  });

  if (listingId) {
    params.set("listingId", listingId);
  }

  const response = await fetch(`${apiUrl}/widget/reviews/summary?${params.toString()}`);
  
  if (!response.ok) {
    throw new Error(`Failed to fetch reviews summary: ${response.statusText}`);
  }

  const json = await response.json();
  return json.data;
}

type FetchReviewsListParams = {
  apiUrl?: string;
  businessSlug: string;
  scope?: ReviewsScope;
  listingId?: string;
  listingType?: ListingType;
  page?: number;
  limit?: number;
};

export async function fetchReviewsList({
  apiUrl = DEFAULT_API_URL,
  businessSlug,
  scope = "business",
  listingId,
  listingType = "course",
  page = 1,
  limit = 10,
}: FetchReviewsListParams): Promise<ReviewsListResponse> {
  const params = new URLSearchParams({
    businessSlug,
    scope,
    listingType,
    page: page.toString(),
    limit: limit.toString(),
  });

  if (listingId) {
    params.set("listingId", listingId);
  }

  const response = await fetch(`${apiUrl}/widget/reviews/list?${params.toString()}`);
  
  if (!response.ok) {
    throw new Error(`Failed to fetch reviews list: ${response.statusText}`);
  }

  const json = await response.json();
  return json.data;
}

